// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3W-Vt","productName":"Table_productName__36jTD"};